import ActivitiesPage from "./ActivitiesPage";

export default ActivitiesPage;
